import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/public/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: { title: '首页' },
    component: () => import('@/views/home/index'),
  },
  {
    path: '/pricie',
    meta: { title: '定价和服务' },
    component: () => import('@/views/home/pricie'),
  },
  {
    path: '/locations',
    meta: { title: '位置' },
    component: () => import('@/views/home/locations'),
  },
  {
    path: '/login',
    meta: { title: '登录' },
    component: () => import('@/views/login/index'),
  },
  {
    path: '/sign',
    meta: { title: '注册' },
    component: () => import('@/views/login/login_page'),
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/order/index'),
        meta: { title: '我的订单' },
      },
      {
        path: 'placeorder',
        component: () => import('@/views/order/placeorder'),
        meta: { title: '下单' },
      },
      {
        path: 'orderdetail',
        component: () => import('@/views/order/orderdetail'),
        meta: { title: '订单详情' },
      },
      {
        path: 'orderprogress',
        component: () => import('@/views/order/orderprogress'),
        meta: { title: '订单追踪' },
      },
      {
        path: 'payment',
        component: () => import('@/views/order/payment'),
        meta: { title: '订单支付' },
      },
      {
        path: 'paymentcomplete',
        component: () => import('@/views/order/paymentcomplete'),
        meta: { title: '订单成功' },
      },
    ],
  },
  {
    path: '/userinfo',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/userInfo/index'),
        meta: { title: '个人中心' },
      },
      {
        path: 'giftcard',
        component: () => import('@/views/userInfo/giftcard'),
        meta: { title: '礼品卡' },
      },
      {
        path: 'coupon',
        component: () => import('@/views/userInfo/coupon'),
        meta: { title: '优惠券' },
      },
      {
        path: 'address',
        component: () => import('@/views/userInfo/address'),
        meta: { title: '我的地址' },
      },
      {
        path: 'newaddress',
        component: () => import('@/views/userInfo/newaddress'),
        meta: { title: '编辑地址' },
      },
      {
        path: 'company',
        component: () => import('@/views/userInfo/company'),
        meta: { title: '绑定公司' },
      },
      {
        path: 'email',
        component: () => import('@/views/userInfo/email'),
        meta: { title: '我的邮箱' },
      },
      {
        path: 'password',
        component: () => import('@/views/userInfo/password'),
        meta: { title: '修改密码' },
      },
      {
        path: 'request',
        component: () => import('@/views/userInfo/request'),
        meta: { title: '注销账号' },
      },
      {
        path: 'requestcomplete',
        component: () => import('@/views/userInfo/request_complete'),
        meta: { title: '注销成功' },
      },
    ],
  },
]

const router = new VueRouter({
  routes,
})

export default router
